const FORMAT_BOOL = 0;

export function getEditFormInput(variable) {
  var repre = variable.representation;
  if (repre.includes("#")) {
    var regex = new RegExp('#([0-9])="(.*?)"', 'g');
    var res = [...repre.matchAll(regex)];
    let arr = [{ value: null, text: '' }];
    for (var i = 0; i < res.length; i++) {
      arr.push({
        value: res[i][1],
        text: res[i][2]
      });
    }
    return arr;
  }
  if ((variable.type & 0x7) == FORMAT_BOOL) {
    return [
      { value: null, text: '' },
      { value: "0", text: "0" },
      { value: "1", text: "1" }
    ];
  }
  return null;
}

export function getTagSelectionInput(variable) {
  try {
    var tag = variable.tag;
    var option = isSelectVariable(tag);
    if (option === -1) return null;
    var split = tag.split(',');
    var desc = split.slice(2, split.length);
    let arr = [{ value: null, text: '' }];
    switch (option) {
      case 0:
        for (var i = 0; i < desc.length; i++) {
          arr.push({
            value: i,
            text: desc[i]
          });
        }
        return arr;
      case 1:
        for (var i = 0; i < desc.length; i++) {
          arr.push({
            value: i + 1,
            text: desc[i]
          });
        }
        return arr;
      case 2:
        desc = desc[0].split(';');
        for (var i = 0; i < desc.length; i++) {
          arr.push({
            value: i,
            text: desc[i].split('.')[0]
          });
        }
        return arr;
    }
    return null;
  } catch (err) {
    return null;
  }
}

export function isSelectVariable(tag) {
  if (tag.toUpperCase().startsWith("ZPOPIS0")) return 0;
  if (tag.toUpperCase().startsWith("ZPOPIS1")) return 1;
  if (tag.toUpperCase().startsWith("ZPOPIS2")) return 2;
  return -1;
}